import { TComposeValidators, TValidationResponse } from './types';

export const composeValidators: TComposeValidators = (...validators) => (value: any, allValues: any) =>
  validators.reduce<TValidationResponse>((error, validator) => error || validator(value, allValues), undefined);
